<template>
  <div class="stage1">
    <div class="text-wrapper animation-text" :class="[{active: activePage}]">

      <div class="text-wrapper__line ">

        <p>
        <span class="animation-text1">
          Merge
        </span>
        </p>

        <div class="flip-box" :class="[{ active: !showLogo }]">
          <div class="flip-box-inner">
            <div class="flip-box-front">
              <img src="@/assets/images/app_icon.png" alt="">
            </div>
            <div class="flip-box-back">
              <svg viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.88892 75.1113H5.7778V72.2224H2.88892V75.1113ZM5.7778 75.1113H8.66669V72.2224H5.7778V75.1113ZM8.66669 75.1113H11.5556V72.2224H8.66669V75.1113ZM11.5556 75.1113H14.4445V72.2224H11.5556V75.1113ZM14.4445 75.1113H17.3334V72.2224H14.4445V75.1113ZM17.3334 75.1113H20.2222V72.2224H17.3334V75.1113ZM20.2222 75.1113H23.1111V72.2224H20.2222V75.1113ZM37.5556 75.1113H40.4445V72.2224H37.5556V75.1113ZM49.1111 75.1113H52V72.2224H49.1111V75.1113ZM54.8889 75.1113H57.7778V72.2224H54.8889V75.1113ZM57.7778 75.1113H60.6667V72.2224H57.7778V75.1113ZM60.6667 75.1113H63.5556V72.2224H60.6667V75.1113ZM63.5556 75.1113H66.4445V72.2224H63.5556V75.1113ZM66.4445 75.1113H69.3334V72.2224H66.4445V75.1113ZM69.3334 75.1113H72.2222V72.2224H69.3334V75.1113ZM72.2222 75.1113H75.1111V72.2224H72.2222V75.1113ZM2.88892 72.2224H5.7778V69.3336H2.88892V72.2224ZM20.2222 72.2224H23.1111V69.3336H20.2222V72.2224ZM26 72.2224H28.8889V69.3336H26V72.2224ZM31.7778 72.2224H34.6667V69.3336H31.7778V72.2224ZM37.5556 72.2224H40.4445V69.3336H37.5556V72.2224ZM46.2222 72.2224H49.1111V69.3336H46.2222V72.2224ZM54.8889 72.2224H57.7778V69.3336H54.8889V72.2224ZM72.2222 72.2224H75.1111V69.3336H72.2222V72.2224ZM2.88892 69.3336H5.7778V66.4447H2.88892V69.3336ZM8.66669 69.3336H11.5556V66.4447H8.66669V69.3336ZM11.5556 69.3336H14.4445V66.4447H11.5556V69.3336ZM14.4445 69.3336H17.3334V66.4447H14.4445V69.3336ZM20.2222 69.3336H23.1111V66.4447H20.2222V69.3336ZM43.3334 69.3336H46.2222V66.4447H43.3334V69.3336ZM49.1111 69.3336H52V66.4447H49.1111V69.3336ZM54.8889 69.3336H57.7778V66.4447H54.8889V69.3336ZM60.6667 69.3336H63.5556V66.4447H60.6667V69.3336ZM63.5556 69.3336H66.4445V66.4447H63.5556V69.3336ZM66.4445 69.3336H69.3334V66.4447H66.4445V69.3336ZM72.2222 69.3336H75.1111V66.4447H72.2222V69.3336ZM2.88892 66.4447H5.7778V63.5558H2.88892V66.4447ZM8.66669 66.4447H11.5556V63.5558H8.66669V66.4447ZM11.5556 66.4447H14.4445V63.5558H11.5556V66.4447ZM14.4445 66.4447H17.3334V63.5558H14.4445V66.4447ZM20.2222 66.4447H23.1111V63.5558H20.2222V66.4447ZM26 66.4447H28.8889V63.5558H26V66.4447ZM28.8889 66.4447H31.7778V63.5558H28.8889V66.4447ZM31.7778 66.4447H34.6667V63.5558H31.7778V66.4447ZM37.5556 66.4447H40.4445V63.5558H37.5556V66.4447ZM40.4445 66.4447H43.3334V63.5558H40.4445V66.4447ZM43.3334 66.4447H46.2222V63.5558H43.3334V66.4447ZM54.8889 66.4447H57.7778V63.5558H54.8889V66.4447ZM60.6667 66.4447H63.5556V63.5558H60.6667V66.4447ZM63.5556 66.4447H66.4445V63.5558H63.5556V66.4447ZM66.4445 66.4447H69.3334V63.5558H66.4445V66.4447ZM72.2222 66.4447H75.1111V63.5558H72.2222V66.4447ZM2.88892 63.5558H5.7778V60.6669H2.88892V63.5558ZM8.66669 63.5558H11.5556V60.6669H8.66669V63.5558ZM11.5556 63.5558H14.4445V60.6669H11.5556V63.5558ZM14.4445 63.5558H17.3334V60.6669H14.4445V63.5558ZM20.2222 63.5558H23.1111V60.6669H20.2222V63.5558ZM28.8889 63.5558H31.7778V60.6669H28.8889V63.5558ZM34.6667 63.5558H37.5556V60.6669H34.6667V63.5558ZM43.3334 63.5558H46.2222V60.6669H43.3334V63.5558ZM54.8889 63.5558H57.7778V60.6669H54.8889V63.5558ZM60.6667 63.5558H63.5556V60.6669H60.6667V63.5558ZM63.5556 63.5558H66.4445V60.6669H63.5556V63.5558ZM66.4445 63.5558H69.3334V60.6669H66.4445V63.5558ZM72.2222 63.5558H75.1111V60.6669H72.2222V63.5558ZM2.88892 60.6669H5.7778V57.778H2.88892V60.6669ZM20.2222 60.6669H23.1111V57.778H20.2222V60.6669ZM26 60.6669H28.8889V57.778H26V60.6669ZM28.8889 60.6669H31.7778V57.778H28.8889V60.6669ZM46.2222 60.6669H49.1111V57.778H46.2222V60.6669ZM49.1111 60.6669H52V57.778H49.1111V60.6669ZM54.8889 60.6669H57.7778V57.778H54.8889V60.6669ZM72.2222 60.6669H75.1111V57.778H72.2222V60.6669ZM2.88892 57.778H5.7778V54.8891H2.88892V57.778ZM5.7778 57.778H8.66669V54.8891H5.7778V57.778ZM8.66669 57.778H11.5556V54.8891H8.66669V57.778ZM11.5556 57.778H14.4445V54.8891H11.5556V57.778ZM14.4445 57.778H17.3334V54.8891H14.4445V57.778ZM17.3334 57.778H20.2222V54.8891H17.3334V57.778ZM20.2222 57.778H23.1111V54.8891H20.2222V57.778ZM26 57.778H28.8889V54.8891H26V57.778ZM31.7778 57.778H34.6667V54.8891H31.7778V57.778ZM37.5556 57.778H40.4445V54.8891H37.5556V57.778ZM43.3334 57.778H46.2222V54.8891H43.3334V57.778ZM49.1111 57.778H52V54.8891H49.1111V57.778ZM54.8889 57.778H57.7778V54.8891H54.8889V57.778ZM57.7778 57.778H60.6667V54.8891H57.7778V57.778ZM60.6667 57.778H63.5556V54.8891H60.6667V57.778ZM63.5556 57.778H66.4445V54.8891H63.5556V57.778ZM66.4445 57.778H69.3334V54.8891H66.4445V57.778ZM69.3334 57.778H72.2222V54.8891H69.3334V57.778ZM72.2222 57.778H75.1111V54.8891H72.2222V57.778ZM28.8889 54.8891H31.7778V52.0002H28.8889V54.8891ZM31.7778 54.8891H34.6667V52.0002H31.7778V54.8891ZM37.5556 54.8891H40.4445V52.0002H37.5556V54.8891ZM46.2222 54.8891H49.1111V52.0002H46.2222V54.8891ZM2.88892 52.0002H5.7778V49.1113H2.88892V52.0002ZM5.7778 52.0002H8.66669V49.1113H5.7778V52.0002ZM8.66669 52.0002H11.5556V49.1113H8.66669V52.0002ZM11.5556 52.0002H14.4445V49.1113H11.5556V52.0002ZM14.4445 52.0002H17.3334V49.1113H14.4445V52.0002ZM20.2222 52.0002H23.1111V49.1113H20.2222V52.0002ZM23.1111 52.0002H26V49.1113H23.1111V52.0002ZM26 52.0002H28.8889V49.1113H26V52.0002ZM28.8889 52.0002H31.7778V49.1113H28.8889V52.0002ZM37.5556 52.0002H40.4445V49.1113H37.5556V52.0002ZM40.4445 52.0002H43.3334V49.1113H40.4445V52.0002ZM43.3334 52.0002H46.2222V49.1113H43.3334V52.0002ZM52 52.0002H54.8889V49.1113H52V52.0002ZM57.7778 52.0002H60.6667V49.1113H57.7778V52.0002ZM63.5556 52.0002H66.4445V49.1113H63.5556V52.0002ZM69.3334 52.0002H72.2222V49.1113H69.3334V52.0002ZM5.7778 49.1113H8.66669V46.2224H5.7778V49.1113ZM8.66669 49.1113H11.5556V46.2224H8.66669V49.1113ZM11.5556 49.1113H14.4445V46.2224H11.5556V49.1113ZM31.7778 49.1113H34.6667V46.2224H31.7778V49.1113ZM34.6667 49.1113H37.5556V46.2224H34.6667V49.1113ZM43.3334 49.1113H46.2222V46.2224H43.3334V49.1113ZM49.1111 49.1113H52V46.2224H49.1111V49.1113ZM52 49.1113H54.8889V46.2224H52V49.1113ZM57.7778 49.1113H60.6667V46.2224H57.7778V49.1113ZM69.3334 49.1113H72.2222V46.2224H69.3334V49.1113ZM8.66669 46.2224H11.5556V43.3336H8.66669V46.2224ZM11.5556 46.2224H14.4445V43.3336H11.5556V46.2224ZM20.2222 46.2224H23.1111V43.3336H20.2222V46.2224ZM26 46.2224H28.8889V43.3336H26V46.2224ZM31.7778 46.2224H34.6667V43.3336H31.7778V46.2224ZM46.2222 46.2224H49.1111V43.3336H46.2222V46.2224ZM49.1111 46.2224H52V43.3336H49.1111V46.2224ZM54.8889 46.2224H57.7778V43.3336H54.8889V46.2224ZM57.7778 46.2224H60.6667V43.3336H57.7778V46.2224ZM60.6667 46.2224H63.5556V43.3336H60.6667V46.2224ZM63.5556 46.2224H66.4445V43.3336H63.5556V46.2224ZM69.3334 46.2224H72.2222V43.3336H69.3334V46.2224ZM72.2222 46.2224H75.1111V43.3336H72.2222V46.2224ZM2.88892 43.3336H5.7778V40.4447H2.88892V43.3336ZM8.66669 43.3336H11.5556V40.4447H8.66669V43.3336ZM11.5556 43.3336H14.4445V40.4447H11.5556V43.3336ZM17.3334 43.3336H20.2222V40.4447H17.3334V43.3336ZM23.1111 43.3336H26V40.4447H23.1111V43.3336ZM34.6667 43.3336H37.5556V40.4447H34.6667V43.3336ZM54.8889 43.3336H57.7778V40.4447H54.8889V43.3336ZM72.2222 43.3336H75.1111V40.4447H72.2222V43.3336ZM5.7778 40.4447H8.66669V37.5558H5.7778V40.4447ZM11.5556 40.4447H14.4445V37.5558H11.5556V40.4447ZM20.2222 40.4447H23.1111V37.5558H20.2222V40.4447ZM26 40.4447H28.8889V37.5558H26V40.4447ZM28.8889 40.4447H31.7778V37.5558H28.8889V40.4447ZM31.7778 40.4447H34.6667V37.5558H31.7778V40.4447ZM34.6667 40.4447H37.5556V37.5558H34.6667V40.4447ZM37.5556 40.4447H40.4445V37.5558H37.5556V40.4447ZM40.4445 40.4447H43.3334V37.5558H40.4445V40.4447ZM52 40.4447H54.8889V37.5558H52V40.4447ZM54.8889 40.4447H57.7778V37.5558H54.8889V40.4447ZM57.7778 40.4447H60.6667V37.5558H57.7778V40.4447ZM60.6667 40.4447H63.5556V37.5558H60.6667V40.4447ZM66.4445 40.4447H69.3334V37.5558H66.4445V40.4447ZM69.3334 40.4447H72.2222V37.5558H69.3334V40.4447ZM72.2222 40.4447H75.1111V37.5558H72.2222V40.4447ZM2.88892 37.5558H5.7778V34.6669H2.88892V37.5558ZM8.66669 37.5558H11.5556V34.6669H8.66669V37.5558ZM11.5556 37.5558H14.4445V34.6669H11.5556V37.5558ZM14.4445 37.5558H17.3334V34.6669H14.4445V37.5558ZM17.3334 37.5558H20.2222V34.6669H17.3334V37.5558ZM23.1111 37.5558H26V34.6669H23.1111V37.5558ZM26 37.5558H28.8889V34.6669H26V37.5558ZM34.6667 37.5558H37.5556V34.6669H34.6667V37.5558ZM40.4445 37.5558H43.3334V34.6669H40.4445V37.5558ZM49.1111 37.5558H52V34.6669H49.1111V37.5558ZM57.7778 37.5558H60.6667V34.6669H57.7778V37.5558ZM63.5556 37.5558H66.4445V34.6669H63.5556V37.5558ZM69.3334 37.5558H72.2222V34.6669H69.3334V37.5558ZM2.88892 34.6669H5.7778V31.778H2.88892V34.6669ZM11.5556 34.6669H14.4445V31.778H11.5556V34.6669ZM17.3334 34.6669H20.2222V31.778H17.3334V34.6669ZM20.2222 34.6669H23.1111V31.778H20.2222V34.6669ZM26 34.6669H28.8889V31.778H26V34.6669ZM28.8889 34.6669H31.7778V31.778H28.8889V34.6669ZM31.7778 34.6669H34.6667V31.778H31.7778V34.6669ZM37.5556 34.6669H40.4445V31.778H37.5556V34.6669ZM40.4445 34.6669H43.3334V31.778H40.4445V34.6669ZM43.3334 34.6669H46.2222V31.778H43.3334V34.6669ZM46.2222 34.6669H49.1111V31.778H46.2222V34.6669ZM52 34.6669H54.8889V31.778H52V34.6669ZM54.8889 34.6669H57.7778V31.778H54.8889V34.6669ZM57.7778 34.6669H60.6667V31.778H57.7778V34.6669ZM60.6667 34.6669H63.5556V31.778H60.6667V34.6669ZM63.5556 34.6669H66.4445V31.778H63.5556V34.6669ZM69.3334 34.6669H72.2222V31.778H69.3334V34.6669ZM72.2222 34.6669H75.1111V31.778H72.2222V34.6669ZM2.88892 31.778H5.7778V28.8891H2.88892V31.778ZM11.5556 31.778H14.4445V28.8891H11.5556V31.778ZM14.4445 31.778H17.3334V28.8891H14.4445V31.778ZM23.1111 31.778H26V28.8891H23.1111V31.778ZM43.3334 31.778H46.2222V28.8891H43.3334V31.778ZM46.2222 31.778H49.1111V28.8891H46.2222V31.778ZM52 31.778H54.8889V28.8891H52V31.778ZM54.8889 31.778H57.7778V28.8891H54.8889V31.778ZM57.7778 31.778H60.6667V28.8891H57.7778V31.778ZM60.6667 31.778H63.5556V28.8891H60.6667V31.778ZM72.2222 31.778H75.1111V28.8891H72.2222V31.778ZM2.88892 28.8891H5.7778V26.0002H2.88892V28.8891ZM14.4445 28.8891H17.3334V26.0002H14.4445V28.8891ZM20.2222 28.8891H23.1111V26.0002H20.2222V28.8891ZM26 28.8891H28.8889V26.0002H26V28.8891ZM34.6667 28.8891H37.5556V26.0002H34.6667V28.8891ZM37.5556 28.8891H40.4445V26.0002H37.5556V28.8891ZM40.4445 28.8891H43.3334V26.0002H40.4445V28.8891ZM43.3334 28.8891H46.2222V26.0002H43.3334V28.8891ZM49.1111 28.8891H52V26.0002H49.1111V28.8891ZM52 28.8891H54.8889V26.0002H52V28.8891ZM54.8889 28.8891H57.7778V26.0002H54.8889V28.8891ZM57.7778 28.8891H60.6667V26.0002H57.7778V28.8891ZM60.6667 28.8891H63.5556V26.0002H60.6667V28.8891ZM66.4445 28.8891H69.3334V26.0002H66.4445V28.8891ZM26 26.0002H28.8889V23.1113H26V26.0002ZM28.8889 26.0002H31.7778V23.1113H28.8889V26.0002ZM31.7778 26.0002H34.6667V23.1113H31.7778V26.0002ZM34.6667 26.0002H37.5556V23.1113H34.6667V26.0002ZM46.2222 26.0002H49.1111V23.1113H46.2222V26.0002ZM49.1111 26.0002H52V23.1113H49.1111V26.0002ZM60.6667 26.0002H63.5556V23.1113H60.6667V26.0002ZM63.5556 26.0002H66.4445V23.1113H63.5556V26.0002ZM2.88892 23.1113H5.7778V20.2224H2.88892V23.1113ZM5.7778 23.1113H8.66669V20.2224H5.7778V23.1113ZM8.66669 23.1113H11.5556V20.2224H8.66669V23.1113ZM11.5556 23.1113H14.4445V20.2224H11.5556V23.1113ZM14.4445 23.1113H17.3334V20.2224H14.4445V23.1113ZM17.3334 23.1113H20.2222V20.2224H17.3334V23.1113ZM20.2222 23.1113H23.1111V20.2224H20.2222V23.1113ZM26 23.1113H28.8889V20.2224H26V23.1113ZM28.8889 23.1113H31.7778V20.2224H28.8889V23.1113ZM37.5556 23.1113H40.4445V20.2224H37.5556V23.1113ZM43.3334 23.1113H46.2222V20.2224H43.3334V23.1113ZM49.1111 23.1113H52V20.2224H49.1111V23.1113ZM54.8889 23.1113H57.7778V20.2224H54.8889V23.1113ZM60.6667 23.1113H63.5556V20.2224H60.6667V23.1113ZM66.4445 23.1113H69.3334V20.2224H66.4445V23.1113ZM69.3334 23.1113H72.2222V20.2224H69.3334V23.1113ZM72.2222 23.1113H75.1111V20.2224H72.2222V23.1113ZM2.88892 20.2224H5.7778V17.3336H2.88892V20.2224ZM20.2222 20.2224H23.1111V17.3336H20.2222V20.2224ZM28.8889 20.2224H31.7778V17.3336H28.8889V20.2224ZM34.6667 20.2224H37.5556V17.3336H34.6667V20.2224ZM49.1111 20.2224H52V17.3336H49.1111V20.2224ZM60.6667 20.2224H63.5556V17.3336H60.6667V20.2224ZM63.5556 20.2224H66.4445V17.3336H63.5556V20.2224ZM69.3334 20.2224H72.2222V17.3336H69.3334V20.2224ZM72.2222 20.2224H75.1111V17.3336H72.2222V20.2224ZM2.88892 17.3336H5.7778V14.4447H2.88892V17.3336ZM8.66669 17.3336H11.5556V14.4447H8.66669V17.3336ZM11.5556 17.3336H14.4445V14.4447H11.5556V17.3336ZM14.4445 17.3336H17.3334V14.4447H14.4445V17.3336ZM20.2222 17.3336H23.1111V14.4447H20.2222V17.3336ZM26 17.3336H28.8889V14.4447H26V17.3336ZM28.8889 17.3336H31.7778V14.4447H28.8889V17.3336ZM31.7778 17.3336H34.6667V14.4447H31.7778V17.3336ZM34.6667 17.3336H37.5556V14.4447H34.6667V17.3336ZM37.5556 17.3336H40.4445V14.4447H37.5556V17.3336ZM40.4445 17.3336H43.3334V14.4447H40.4445V17.3336ZM43.3334 17.3336H46.2222V14.4447H43.3334V17.3336ZM46.2222 17.3336H49.1111V14.4447H46.2222V17.3336ZM49.1111 17.3336H52V14.4447H49.1111V17.3336ZM52 17.3336H54.8889V14.4447H52V17.3336ZM54.8889 17.3336H57.7778V14.4447H54.8889V17.3336ZM57.7778 17.3336H60.6667V14.4447H57.7778V17.3336ZM60.6667 17.3336H63.5556V14.4447H60.6667V17.3336ZM66.4445 17.3336H69.3334V14.4447H66.4445V17.3336ZM69.3334 17.3336H72.2222V14.4447H69.3334V17.3336ZM2.88892 14.4447H5.7778V11.5558H2.88892V14.4447ZM8.66669 14.4447H11.5556V11.5558H8.66669V14.4447ZM11.5556 14.4447H14.4445V11.5558H11.5556V14.4447ZM14.4445 14.4447H17.3334V11.5558H14.4445V14.4447ZM20.2222 14.4447H23.1111V11.5558H20.2222V14.4447ZM26 14.4447H28.8889V11.5558H26V14.4447ZM34.6667 14.4447H37.5556V11.5558H34.6667V14.4447ZM40.4445 14.4447H43.3334V11.5558H40.4445V14.4447ZM49.1111 14.4447H52V11.5558H49.1111V14.4447ZM52 14.4447H54.8889V11.5558H52V14.4447ZM54.8889 14.4447H57.7778V11.5558H54.8889V14.4447ZM60.6667 14.4447H63.5556V11.5558H60.6667V14.4447ZM63.5556 14.4447H66.4445V11.5558H63.5556V14.4447ZM66.4445 14.4447H69.3334V11.5558H66.4445V14.4447ZM69.3334 14.4447H72.2222V11.5558H69.3334V14.4447ZM72.2222 14.4447H75.1111V11.5558H72.2222V14.4447ZM2.88892 11.5558H5.7778V8.66689H2.88892V11.5558ZM8.66669 11.5558H11.5556V8.66689H8.66669V11.5558ZM11.5556 11.5558H14.4445V8.66689H11.5556V11.5558ZM14.4445 11.5558H17.3334V8.66689H14.4445V11.5558ZM20.2222 11.5558H23.1111V8.66689H20.2222V11.5558ZM26 11.5558H28.8889V8.66689H26V11.5558ZM31.7778 11.5558H34.6667V8.66689H31.7778V11.5558ZM40.4445 11.5558H43.3334V8.66689H40.4445V11.5558ZM43.3334 11.5558H46.2222V8.66689H43.3334V11.5558ZM46.2222 11.5558H49.1111V8.66689H46.2222V11.5558ZM63.5556 11.5558H66.4445V8.66689H63.5556V11.5558ZM66.4445 11.5558H69.3334V8.66689H66.4445V11.5558ZM72.2222 11.5558H75.1111V8.66689H72.2222V11.5558ZM2.88892 8.66689H5.7778V5.778H2.88892V8.66689ZM20.2222 8.66689H23.1111V5.778H20.2222V8.66689ZM26 8.66689H28.8889V5.778H26V8.66689ZM34.6667 8.66689H37.5556V5.778H34.6667V8.66689ZM43.3334 8.66689H46.2222V5.778H43.3334V8.66689ZM46.2222 8.66689H49.1111V5.778H46.2222V8.66689ZM49.1111 8.66689H52V5.778H49.1111V8.66689ZM52 8.66689H54.8889V5.778H52V8.66689ZM54.8889 8.66689H57.7778V5.778H54.8889V8.66689ZM57.7778 8.66689H60.6667V5.778H57.7778V8.66689ZM60.6667 8.66689H63.5556V5.778H60.6667V8.66689ZM63.5556 8.66689H66.4445V5.778H63.5556V8.66689ZM72.2222 8.66689H75.1111V5.778H72.2222V8.66689ZM2.88892 5.778H5.7778V2.88911H2.88892V5.778ZM5.7778 5.778H8.66669V2.88911H5.7778V5.778ZM8.66669 5.778H11.5556V2.88911H8.66669V5.778ZM11.5556 5.778H14.4445V2.88911H11.5556V5.778ZM14.4445 5.778H17.3334V2.88911H14.4445V5.778ZM17.3334 5.778H20.2222V2.88911H17.3334V5.778ZM20.2222 5.778H23.1111V2.88911H20.2222V5.778ZM26 5.778H28.8889V2.88911H26V5.778ZM31.7778 5.778H34.6667V2.88911H31.7778V5.778ZM40.4445 5.778H43.3334V2.88911H40.4445V5.778ZM43.3334 5.778H46.2222V2.88911H43.3334V5.778ZM52 5.778H54.8889V2.88911H52V5.778ZM54.8889 5.778H57.7778V2.88911H54.8889V5.778ZM57.7778 5.778H60.6667V2.88911H57.7778V5.778ZM60.6667 5.778H63.5556V2.88911H60.6667V5.778ZM63.5556 5.778H66.4445V2.88911H63.5556V5.778ZM66.4445 5.778H69.3334V2.88911H66.4445V5.778ZM69.3334 5.778H72.2222V2.88911H69.3334V5.778ZM72.2222 5.778H75.1111V2.88911H72.2222V5.778Z"
                    fill="black"/>
              </svg>
            </div>
          </div>
        </div>

        <p>
        <span class="animation-text2">
          your
        </span>
        </p>

      </div>

      <div class="text-wrapper__line second-line">

        <p>
        <span class="animation-text3">
          physical
        </span>
        </p>

        <p>
        <span class="animation-text4">
          &nbsp;world
        </span>
        </p>

      </div>

      <div class="text-wrapper__line">

        <p>
        <span class="animation-text5">
          with
        </span>
        </p>

        <p>
        <span class="bold animation-text6">
          &nbsp;digital
        </span>
        </p>

        <p>
        <span class="bold animation-text7">
           &nbsp;magic
        </span>
        </p>

      </div>

    </div>

  </div>
</template>

<script>
import {gsap} from "gsap";
import {mapGetters} from "vuex";


export default {
  name: "stage1",

  data: () => ({
    showLogo: true,
    activePage: false
  }),

  mounted() {
    if (!this.getPreloader) {
      this.animationText()
    }
  },

  watch: {
    'getPreloader'(to, from) {
      if (to === false) {
        this.animationText()
      }
    }
  },

  computed: {
    ...mapGetters(['getPreloader']),
  },
  methods: {

    animationText() {
      gsap.to(['.animation-text p span', '.animation-text .flip-box'], {y: '110%', opacity: 0, duration: 0})
      let tl = gsap.timeline();
      tl
          .to('.animation-text1', {y: "0%", duration: .35, delay: .2, opacity: 1, ease: "back"})
          .to('.animation-text .flip-box', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.3)
          .to('.animation-text2', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.4)
          .to('.animation-text3', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.5)
          .to('.animation-text4', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.6)
          .to('.animation-text5', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.7)
          .to('.animation-text6', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.8)
          .to('.animation-text7', {y: "0%", duration: .35, opacity: 1, ease: "back"}, 0.9)
          .add(() => {
            setTimeout(() => {
              this.showLogo = false
            }, 200)
          });
    }
  }
}
</script>

<style scoped lang="scss">
.stage1 {
  @import "@/assets/style/styles";

  min-height: calc((var(--vh, 1vh) * 100));
  max-height: calc((var(--vh, 1vh) * 100));
  height: 100%;
  width: 100%;
  position: relative;

  .text-wrapper {
    position: absolute;
    left: 20px;
    bottom: 50px;

    &__line {
      display: flex;
      align-items: center;
      overflow: hidden;

      &:first-child {
        margin-bottom: -10px;
      }

      &.second-line {
        padding-left: 144px;
      }
    }

    p {
      display: inline-block;
      overflow: hidden;

      span {
        font-size: 140px;
        line-height: 120px;
        font-family: $thin;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.6);
        display: inline-block;


        mix-blend-mode: normal;

        @media screen and (max-width: 1645px) {
          font-size: 120px;
          line-height: 100px;
        }
        @media screen and (max-width: 1500px) {
          font-size: 80px;
          line-height: 80px;
        }


        &.bold {
          font-family: $ELightI;
          font-style: italic;
          color: white;

        }
      }
    }
  }

  .flip-box {
    background-color: transparent;
    width: 122px;
    height: 122px;
    margin: 10px 20px;
    perspective: 1000px;

    display: inline-block;

    @media screen and (max-width: 1500px) {
      width: 100px;
      height: 100px;
    }
  }

  .flip-box-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 1.5s;
    transform-style: preserve-3d;
  }

  .flip-box.active .flip-box-inner {
    transform: rotateY(180deg);
  }

  .flip-box-front, .flip-box-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .flip-box-front {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .flip-box-back {
    transform: rotateY(180deg);

    background: white;
    border-radius: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 122px;
    height: 122px;

    @media screen and (max-width: 1500px) {
      width: 100px;
      height: 100px;
    }

    svg {
      width: 76px;
      height: auto;
      display: block;

      @media screen and (max-width: 1500px) {
        width: 66px;
      }
    }
  }
}
</style>